<template lang="pug">
  v-data-table(
    class="pt-4",
    :headers="headers",
    :items="divisionList",
    :loading="loading",
    no-data-text="Нет подразделений для указаного подразделения",
    hide-actions)
    template(slot="items" slot-scope="props")
      td {{ props.index + 1 }}
      td {{ props.item.name }}
      td
        a(@click="") Просмотреть
      td
        a(@click="") Редактировать
      td
        a(@click="", class="red--text") Удалить
</template>

<script>
// import axios from 'axios/index'
export default {
  name: 'DivisionsItemTable',
  props: {
    organisationId: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    headers: [
      { text: '№', value: 'id', sortable: false },
      { text: 'Название', value: 'name' },
      { text: 'Действие', value: 'action1', sortable: false, align: 'left' },
      { text: 'Действие', value: 'action2', sortable: false, align: 'left' },
      { text: 'Действие', value: 'action3', sortable: false, align: 'left' }
    ],
    divisionList: [],
    loading: false
  }),
  mounted() {
    // this.getDivisionList()
  },
  methods: {
    // getDivisionList() {
    //   axios({
    //     method: 'GET',
    //     url: `/api/Division/list/${this.organisationId}`
    //   }).then(response => {
    //     this.divisionList = response.data.result
    //   }).catch(error => {
    //     console.log(error)
    //   })
    // }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/OrganisationStructure/Division/DivisionItem/DivisionItemTable/DivisionItemTable.vue